// extracted by mini-css-extract-plugin
module.exports = {"image":"CustomImage_image__s9IQk","priority":"CustomImage_priority__urwpP","fade":"CustomImage_fade__luV9c","loaded":"CustomImage_loaded__Xagdp"};